module.exports = __webpack_public_path__ + "static/media/btn-soat.7c67688c.png";